import React from 'react';

import EditorExpandIcon from '@atlaskit/icon/glyph/editor/expand';

import IssueTypesSelect from 'src/views/Admin/Modals/EditRuleModal/RuleForm/components/IssueTypesSelect';
import { useIssuesMetadata } from 'src/views/Admin/Modals/EditRuleModal/RuleForm/components/RuleFormContext';
import Field from 'src/views/components/Form/Field';
import { ProjectsSelect, ServicesSelect } from 'src/views/components/select';

const Scope = ({ name, values = {}, touched = {}, errors = {}, onChange, onBlur }) => {
  const { loading } = useIssuesMetadata();

  return (
    <div style={{ display: 'flex', width: '100%' }}>
      <div style={{ width: '40%' }}>
        <Field label="Select PagerDuty service(s)" isRequired errorMessage={touched.services && errors.services}>
          <ServicesSelect
            name={`${name}.services`}
            value={values.services}
            onChange={onChange}
            onBlur={onBlur}
            isMulti
          />
        </Field>
      </div>
      <div style={{ display: 'flex', flexFlow: 'row nowrap', margin: '20px 20px 0' }}><EditorExpandIcon size="xlarge"/></div>
      <div style={{ width: '60%', display: 'flex', flexFlow: 'row nowrap' }}>
        <div style={{ width: '50%' }}>
          <Field label="Select Jira Project(s)" isRequired errorMessage={touched.projects && errors.projects}>
            <ProjectsSelect
              name={`${name}.projects`}
              value={values.projects}
              onChange={onChange}
              onBlur={onBlur}
              isMulti
            />
          </Field>
        </div>
        <div style={{ width: '10px' }}></div>
        <div style={{ width: '50%' }}>
          <Field label="Select Jira Issue type(s)"
            isRequired
            errorMessage={touched.issue_types && errors.issue_types}
            helperMessage={loading && 'Loading JIRA metadata...'}
          >
            <IssueTypesSelect
              name={`${name}.issue_types`}
              value={values.issue_types}
              onChange={onChange}
              onBlur={onBlur}
              isMulti
            />
          </Field>
        </div>
      </div>
    </div>
  );
};

export default Scope;
